import { render, staticRenderFns } from "./InspectionsNotFound.vue?vue&type=template&id=d7da7c78&scoped=true&"
import script from "./InspectionsNotFound.vue?vue&type=script&lang=js&"
export * from "./InspectionsNotFound.vue?vue&type=script&lang=js&"
import style0 from "./InspectionsNotFound.vue?vue&type=style&index=0&id=d7da7c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7da7c78",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VImg})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7da7c78')) {
      api.createRecord('d7da7c78', component.options)
    } else {
      api.reload('d7da7c78', component.options)
    }
    module.hot.accept("./InspectionsNotFound.vue?vue&type=template&id=d7da7c78&scoped=true&", function () {
      api.rerender('d7da7c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/InspectionsNotFound.vue"
export default component.exports